// extracted by mini-css-extract-plugin
module.exports = {"collapsibleContentWrapper":"AlertEventExpandableText_collapsibleContentWrapper__2X9dL","actionsMargin":"AlertEventExpandableText_actionsMargin__1kJug"};